<template>
  <router-view v-slot="{ Component }">
    <transition mode="out-in" name="fade-transform">
      <component :is="Component" v-if="Component" :key="route.path"/>
    </transition>
  </router-view>
</template>

<script lang="ts" setup>
import {onBeforeMount} from 'vue';
import {useRoute} from 'vue-router';
import {useAppTracking} from '@/composables/useAppTracking';

const route = useRoute();
const {initGoogleAnalytics} = useAppTracking();

onBeforeMount(() => {
  initGoogleAnalytics();
});
</script>

<style>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.options-subtitle {
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin-top: 5px;
}
</style>
